import ledgers from 'assets/images/ledgers.png';
import stars from 'assets/images/stars.png';

const IMAGES = {
  ledgers,
  stars,
} as const;

export default IMAGES;
